export default __webpack_public_path__ + "static/media/asiera-logo-white.898c1e26.png";